import React from 'react'
import { Container, Header, Divider } from 'semantic-ui-react'

const HomePage = () => (
  <Container textAlign='justified'>
    <Header as="h2">Conhecimento</Header>

    <p>
      Desenvolvo com Python desde 2011, já fiz projetos com foco em visão computacional, sistemas web, IoT, bots... Uma 
      infinidade de coisas. Participo ativamente no grupo Python Brasil e gosto muito de ajudar as pessoas que estão dando
      seus primeiros passos na computação. Python foi a minha linguagem de programação principal por muito tempo.
    </p>

    <br />

    <p>
      Já desenvolvi nativamente para Android (customizando o Android através do CyanogenMod) e Windows 10. Já trabalhei com apps hibridos escritos com base em frameworks
      como Cordova e Ionic. Programei em Scala, Haskell, Java, Kotlin, Groovy, Clojure (fiz um trabalhado na disciplina de Compiladores com
      Clojure) e Erlang.
    </p>

    <br />

    <p>
      Hoje em dia eu concentro meus esforços em projetos com base no Node.js e quando preciso desenvolver alguma
      interface, React.js é a minha primeira opção. JavaScript foi amor desde o primeiro script, é uma linguagem fantástica
      com uma comunidade fantástica por trás.
    </p>

    <Divider />

    <Header as="h2">Formação</Header>
    <p>
      Cursei 6 semestres Meteorologia na Universidade Federal de Pelotas (2011-2013). Nestes 6 semestres tive a oportunidade
      de trabalhar como monitor de Álgebra Linear e Geometria Analítica e de Cálculo 3 no Instituto de Física e Matemática.
      Também trabalhei como iniciação ciêntifica na área de sensoriamento remoto com o satélite CALIPSO. Ao longo do tempo
      que passei na Meteorologia, descobri a minha verdadeira vocação estava na Computação.
    </p>

    <br />
    
    <p>
      Entrei para o curso de Engenharia de Computação, na Universidade Federal de Pelotas, em 2014 e estou neste curso desde então.
      Tive a oportunidade de trabalhar em um projeto de extensão ensinando fundamentos de computação para crianças, também 
      trabalhei com tecnologias assistivas com o bracele <a href="https://www.myo.com/">Myo</a> e mais recentemente estou
      trabalhando no meu trabalho de conclusão de curso que será o desenvolvimento de operadores da lógica fuzzy intucionista
      aplicados à computação quântica.
    </p>

    <br />

    <Divider />

    <Header as="h2">Participações em eventos</Header>

    <p>
      Palestrei no FLISoL 2015 sobre programação funcional com Scala e no Tchê Linux 2016 sobre programação funcional com 
      Haskell. Também participei como ouvinte nas semanas acadêmicas da computação nos anos 2014, 
    </p>

    <Divider />
    
  </Container>
)

export default HomePage


// WEBPACK FOOTER //
// ./src/components/HomePage.js